/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * The type of holder on a funding source.
 */
export const BankAccountHolderType = {
  Individual: "individual",
  Business: "business",
  Guest: "guest",
} as const;
/**
 * The type of holder on a funding source.
 */
export type BankAccountHolderType = ClosedEnum<typeof BankAccountHolderType>;

/** @internal */
export const BankAccountHolderType$inboundSchema: z.ZodNativeEnum<
  typeof BankAccountHolderType
> = z.nativeEnum(BankAccountHolderType);
/** @internal */
export const BankAccountHolderType$outboundSchema: z.ZodNativeEnum<
  typeof BankAccountHolderType
> = BankAccountHolderType$inboundSchema;
